var BaseCollection = require('./base-collection');


var RelationTypesCollection = BaseCollection.extend({
    url:"/api/relationtype",

    initialize: function(models, options){
        BaseCollection.prototype.initialize.apply(this, arguments);
    }
});


module.exports = RelationTypesCollection;


//////////////////
// WEBPACK FOOTER
// ./app/collections/relation-types-collection.js
// module id = 223
// module chunks = 0